import React, { useState } from 'react';
import { MemberNewsModal } from '@/components/memberNewsModal';
import QualifiedModal from '@/components/QualifiedModal';

export interface TopModalPropsForDisplayQueue {
  goNext: (nextIdx?: number) => void;
}

enum ModalIndex {
  Qualified = 0,
  MemberNew = 1
}

const TopModals = () => {
  const [nextModalIdx, setNextModalIdx] = useState<number>(ModalIndex.Qualified);
  const modals = [
    <QualifiedModal
      goNext={(nextIdx?: number) => {
        setNextModalIdx(nextIdx || ModalIndex.MemberNew);
      }}
    />,
    <MemberNewsModal isOpen={true} />
  ];
  return nextModalIdx >= modals.length ? <></> : modals[nextModalIdx];
};

export default TopModals;
